<div class="empty-state">
  <div
    class="icon-container"
    [class.circle-bg]="showCircleBg()"
    [style.width.px]="size()"
    [style.height.px]="size()">
    <svg-icon [src]="icon()"></svg-icon>
  </div>

  @if (text()) {
    <div class="placeholder">{{ text() | translate }}</div>
  }
  
  @if (description()) {
    <span class="description">{{ description() | translate }}</span>
  }

  @if (showButton()) {
    <button
      *hasPermission="managePermissions(); orIf: !managePermissions(); andIf: isEditable()"
      class="app-button app-button_blue"
       type="button"
      (click)="buttonClicked.emit()">
      {{ buttonLabel() | translate }}
    </button>
  }
</div>